<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("concession") }}</div>
      <router-link
        v-if="$can('create', 'Concession')"
        class="btn-blue"
        to="add-concession"
        >{{ $t("add") }}</router-link
      >
    </div>

    <div
      v-if="selectedCinema.length != 0"
      class="d-flex justify-content-between align-items-center my-3"
    >
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onSelect($event, cinema)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper mt-5">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >Cinema</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  href="#"
                  name="selectcine"
                  id="selectcine"
                  @click="onSelect($event, cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="``" /> -->
            </div>
            <p class="error_message"></p>
          </div>
        </div>
      </div>

      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>{{ $t("concession") }}</th>
          </tr>
        </thead>
        <tbody v-if="Concessions.length > 0">
          <tr v-for="(item, key) in Concessions" :key="key">
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    item.cl_is_active === 'Y'
                      ? 'active'
                      : item.cl_is_active === 'N' && 'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Concession')"
                    @click="goToRoute('/cinema-manager/edit-concession', item)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/cinema-manager/view-concession', item)"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.cl_is_active === 'Y' ? 'active' : 'inactive'"
                />

                <i
                  v-if="$can('update', 'Concession')"
                  class="edit-pen icon blue-icon cursor-pointer ml-2"
                  @click.prevent.stop="
                    goToRoute('/cinema-manager/edit-concession', item)
                  "
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>
                <i
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  @click.prevent.stop="
                    goToRoute('/cinema-manager/view-concession', item)
                  "
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>{{ item.cl_name }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="2">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemaService from "@/services/CinemasService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",

      selectedCinema: "",
      Concessions: "",
      isActive: "",
      isRoleID: true,
      Cinemas: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      CinemasCopy: [],
      searchCinema: "",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    let obj = this.secureStore.get("USINFO").cinema_id;

    if (true) {
      this.isRoleID = false;
      this.getCinemasList(obj);
    } else {
      this.getCinemasList(obj);
    }
    this.getviewingnumber();
    // this.getConcessionList();

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.cinemaid = CinemaObj.cine_id;
      this.getConcessionList(CinemaObj.cine_id);
    }
  },
  methods: {
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onSelect(event, cinema) {
      console.log("cinema :", cinema);
      this.selectedCinema = cinema.cine_name;
      this.cinemaid = cinema.cine_id;
      this.getConcessionList(cinema.cine_id);
      // this.getCinemasList(cinema.cine_id);
      this.searchCinema = "";
      this.onSearchCinema();
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getConcessionList;
      } else {
        this.currentPage = event;
        this.getConcessionList();
      }
    },
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.selectedid = {
        cine_id: item.cine_id,
      };
      this.getScreensList(item);
    },

    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            console.log("this.Cinemas :", this.Cinemas);
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                let cine_id = x.cine_id;
                this.getConcessionList(cine_id);
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getConcessionList(cine_id) {
      console.log("cine_id :", cine_id);
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
      };
      let cid = {
        cinema_id: cine_id,
      };
      console.log("payload :", payload);

      CinemaService.listConcession(payload, cid)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Concessions = data.Records;
              console.log("this.Concessions :", this.Concessions);
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.Concessions = [];
              this.$toasted.show("No Records Found");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { cl_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: cl_id,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ConcessionComponents/concession.vue